import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faDollarSign, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import badgeSolid from '../assets/streamline--star-badge-solid.png';
import TransactionCard from '../components/TransactionCard';
import CustomToastContainer from '../components/CustomToastContainer';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { getTransactions } from '../apiServices/apiServices';

export default function Wallet() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [balance, setBalance] = useState(0);

  useEffect(() => {
    const fetchTransactions = async () => {
    const user = JSON.parse(window.localStorage.getItem("user"));
      try {
        const response = await getTransactions(user.id);
        if (response && response.success) {
          setData(response?.data || []);
          setTransactions(response?.data?.transactions);
          setBalance(response?.data?.balance);
        } else {
          console.error(response.message || 'Failed to get balance');
          toast.error(response.message || 'Failed to fetch transactions');
        }
      } catch (error) {
        console.error('Error:', error);
        toast.error('An error occurred. Please try again.');
      }
    };

    fetchTransactions();
  }, []);

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <>
      <div className="flex h-full w-full">
        {/* Main Content */}
        <div className="flex flex-col h-full w-full ">
          {/* Header */}
          <nav className="flex items-center justify-between p-2 sm:p-4 bg-white shadow-md">
            <button className="text-gray-600 flex items-center" onClick={() => handleNavigation(-1)}>
              <FontAwesomeIcon icon={faArrowLeft} size="lg" />
            </button>

            <div className="flex items-center gap-2">
              <h1 className="text-gray-600 font-semibold text-lg text-center">
                  My Wallet
              </h1>
            </div>

            {/* <button className="text-red-500 font-semibold flex items-center justify-end" onClick={() => handleNavigation('/topupOptions')}> */}
            <button className="text-red-500 font-semibold flex items-center justify-end" onClick={() => handleNavigation('/onRideTopup')}>
              <FontAwesomeIcon icon={faPlus} />
              <span className="ml-2">Add Money</span>
            </button>
          </nav>

          {/* Balance Section */}
          <div className="bg-white mb-2 sticky top-[60px] z-20 ">
              <div className="flex items-center p-4 md:px-6 lg:px-8 bg-white">
                <div className="w-10 h-10 md:w-12 md:h-12 p-2 bg-gray-100 rounded-full mr-4 flex items-center justify-center">
                  <FontAwesomeIcon icon={faDollarSign} className="w-7 h-7 text-red-500" />
                </div>
                <h2 className="text-base md:text-lg font-semibold text-gray-600">BALANCE</h2>
                <span className="ml-auto text-base md:text-lg font-semibold text-gray-600 pr-4 md:pr-6">
                  PKR: {balance.toFixed(2)}
                </span>
            </div>

            {/* Coupon */}
            <div className="hidden flex flex-wrap items-center mb-5 p-4 md:px-6 lg:px-8 bg-white rounded-md mt-2 space-y-2 md:space-y-0">
              <div className="flex items-center space-x-2 w-full md:w-auto">
                <img src={badgeSolid} alt="Reward Icon" className="w-6 h-6 md:w-8 md:h-8 lg:w-10 lg:h-10" />
                <p className="text-sm md:text-base lg:text-lg font-bold text-red-500">
                  Use a reward code to avail a cashback
                </p>
              </div>
              <div className="flex items-center w-full md:w-auto md:ml-auto">
                <div className="relative w-full md:w-40 lg:w-48">
                  <input
                    type="text"
                    className="w-full border rounded px-3 py-2 text-gray-800 border-[#BE1F18]"
                    placeholder="Coupon Code"
                  />
                </div>
                <button className="ml-4 bg-red-500 text-white py-1 px-3 rounded-full text-sm md:text-base lg:text-lg font-medium">
                  APPLY
                </button>
              </div>
            </div>
          </div>

          {/* Transactions List */}
          <div className="overflow-auto bg-gray-100 flex-1 p-2 md:p-4 lg:p-6">
            <div className="space-y-0">
              {transactions && transactions.map((item) => (
                <div key={item.id}>
                  <TransactionCard data={item} />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Sidebar - only visible on medium and larger screens */}
        {/* <div className="hidden md:block md:w-2/5 lg:w-2/5 bg-gray-200 p-4">
          {/* Sidebar Content */}
          {/* <div className="flex items-center justify-center">
            <p className=" text-lg font-semibold text-[#BE1F18]">Sidebar Content</p>
          </div>*/}
          {/* Divider */}
          {/* <div className="w-full h-2 bg-gray-100"></div> */} 
          {/* <div>
            <OnRideTopup/>
          </div>
          <div className="bg-white p-5">
            <OnlineTopup/>
          </div> */}
          {/* Add additional sidebar elements here */}
        {/* </div> */} 
      </div>
      <CustomToastContainer />
    </>
  );
}

